import style from "./account.module.scss";
import AccountProfile from "./AccountProfile";
import Card from "./Card";
import AccountMenu from "./AccountMenu";
import Logout from "./Logout";
import useAuth from "../../hooks/useAuth";
import { useMsal } from "@azure/msal-react";
import { passwordResetRequest } from "../../authConfig";
import { useEffect, useState } from "react";
import useSalesforce from "../../hooks/useSalesforce";
import {
  hasActiveParentSubscription,
  hasActiveParentSubscriptionSalesforce,
} from "../../utils/authUtils";

const AccountForLoggedInUser = ({ profileName, email, isEmailVisible }) => {
  const { authDetails, userProfile } = useAuth();
  const { instance, accounts } = useMsal();
  const { isSalesforceEnabled } = useSalesforce();

  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    if (!accounts[0]) {
      return;
    }
    const tgt = localStorage.getItem("tgt");
    if (!tgt) {
      setShowChangePassword(true);
    }
  }, [authDetails]);

  const handlePasswordReset = () => {
    if (!accounts[0]) {
      console.error("No active account found");
      return;
    }

    instance.loginRedirect(passwordResetRequest).catch((e) => {
      console.error(e);
    });
  };

  return (
    <div className={style.loginItems}>
      {authDetails && (
        <AccountProfile name={profileName} email={email} isEmailVisible={isEmailVisible} />
      )}
      <div className={style.cardRow}>
        <Card name="My favourites" route="/app/favourites" iconname="Favourite" />
        <Card name="Saved search" route="/app/savedSearch" iconname="Saved" />
      </div>
      <div className={style.menuList}>
        {showChangePassword && (
          <AccountMenu name="Change password" onClickFuc={handlePasswordReset} />
        )}
        {isSalesforceEnabled && ( // end of s in accountSubscriptions  showing salesforce else accountSubscription
          <AccountMenu name="Subscriptions" route="/app/accountSubscriptions" />
        )}
        {!isSalesforceEnabled && (
          <AccountMenu name="Subscriptions" route="/app/accountSubscription" />
        )}
        {hasActiveParentSubscription(userProfile?.subscriptions) && !isSalesforceEnabled && (
          <AccountMenu name="Manage Users" route={"/app/manageUsers"} />
        )}
        {isSalesforceEnabled &&
          hasActiveParentSubscriptionSalesforce(userProfile?.subscriptions) &&
          userProfile?.subscriptions?.isPrimaryContact && (
            <AccountMenu name="Manage Users" route={"/app/salesforceManageUsers"} />
          )}
        <AccountMenu
          name="What’s New"
          route="https://www.tg.org.au/products/therapeutic-guidelines/updates/"
          isExternal={true}
        />
        <AccountMenu name="About us & Legal" route="/app/aboutUsAndLegal" isExternal={false} />
      </div>
      <div className={style.cardRow}>
        <p>
          We welcome feedback from our community; please contact{" "}
          <a className={style.underline} href="mailto:feedback@tg.org.au">
            feedback@tg.org.au
          </a>
          .
        </p>
      </div>
      <Logout />
    </div>
  );
};

export default AccountForLoggedInUser;
